import { Colors } from './constants';

export default (isSelected: boolean) => (isSelected ? Colors.iosBlue : Colors.darkgray);
